import { defaultSystemCode, exists, SystemCode } from '@/api'

export interface GetOrderListDetail {
  orderBranchCode: SystemCode
  orderNumber: number
}

export function GetOrderListDetailFromJSON(json: any): GetOrderListDetail {
  return {
    orderBranchCode: exists(json, 'order_branch_code')
      ? json.order_branch_code
      : defaultSystemCode(),
    orderNumber: exists(json, 'order_number') ? json.order_number : 0
  }
}
